<template>
  <div>
    <ConversionAreaOne
      v-if="product"
      v-bind="{ tsProduct, product, addOn, agreementCategory, isAdjusted, injectedVideo }"
    />
    <ConversionAreaWithProvider
      v-else-if="shopifyHandle"
      v-bind="{ shopifyHandle, addOn, agreementCategory, isAdjusted, injectedVideo }"
    />
  </div>
</template>

<script lang="ts" setup>
import ConversionAreaOne from './ConversionAreaOne.vue';
import ConversionAreaWithProvider from './ConversionAreaWithProvider.vue';

defineProps({
  product: {
    type: Object,
    default: () => null,
  },
  tsProduct: {
    type: Object,
    default: () => null,
  },
  addOn: {
    type: Object,
    default: () => null,
  },
  agreementCategory: {
    type: Array,
    default: () => null,
  },
  isAdjusted: {
    type: Boolean,
    default: false,
  },
  shopifyHandle: {
    type: String,
    default: null,
  },
  injectedVideo: {
    type: Object,
    default: () => ({}),
  },
});
</script>
